<template>
  <div class="home-page-3">
    <div class="box-title1">
      <div>月抢单趋势</div>
      <div>
        <el-select
          v-model="searchValue"
          @change="handleChange"
          placeholder="请选择"
        >
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="page3-content">
      <lineAreaChart ref="lineAreaChart"></lineAreaChart>
    </div>
  </div>
</template>
<script>
import {
  getAdminBroker,
  downloadPage,
  getOrderTrend,
} from "@/views/HomePage/api";
import { blobToText, downloadFileCustom } from "@/utils/tool";
import lineAreaChart from "./echarts/lineAreaChart";
export default {
  name: "DataOverview",
  components: { lineAreaChart },
  data() {
    return {
      detail: {
        todayNum: 1000,
      },
      searchValue: "2025",
      years: [
        {
          value: "2025",
          label: "2025年",
        },
        {
          value: "2026",
          label: "2026年",
        },
        {
          value: "2027",
          label: "2027年",
        },
        {
          value: "2028",
          label: "2028年",
        },
        {
          value: "2029",
          label: "2029年",
        },
        {
          value: "2030",
          label: "2030年",
        },
      ],
      lineData: [],
    };
  },
  mounted() {
    this.getDetail(this.searchValue);
  },
  methods: {
    handleChange(val) {
      this.getDetail(val);
    },
    getDetail(val) {
      getOrderTrend(val).then((res) => {
        if (res.code === 200) {
          this.lineData = res.data;
          this.$refs.lineAreaChart.initChart(this.lineData);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.home-page-3 {
  width: 100%;
  height: 4rem;
  background-color: #ffffff;
  border-radius: 0.08rem;
  margin-bottom: 0.16rem;
  padding: 0.2rem 0.16rem 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .box-title1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }
  .page3-content {
    width: 100%;
    flex: 1;
  }
}
</style>
